import { EMPTY_STR } from "@/constants/string";
import { EContractStatus } from "@/types/enum";
import { truncateWithEllipsis } from "@/utils/string";

export const getContractPlanLabel = (contractStatus: string | null, plan: string) => {
  const isActiveContract = contractStatus === null || contractStatus === EContractStatus.DURING_CONTRACT || contractStatus === EContractStatus.TRIAL;
  if (isActiveContract && plan) {
    return truncateWithEllipsis(plan, 18);
  }
  if (contractStatus === EContractStatus.TRIAL_CANCELLED) {
    return "トライアル終了";
  }
  if (contractStatus === EContractStatus.CANCELED_CONTRACT) {
    return "解約済み";
  }
  if (contractStatus === EContractStatus.DELETED_CONTRACT) {
    return "削除済み";
  }
  return EMPTY_STR.TEXT;
};
